import SiteFooter from "./SiteFooter";

export const instance = new SiteFooter();

export default { instance };